function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8125 6.5C11.8125 3.3125 9.1875 0.6875 6 0.6875C2.78906 0.6875 0.1875 3.3125 0.1875 6.5C0.1875 9.71094 2.78906 12.3125 6 12.3125C9.1875 12.3125 11.8125 9.71094 11.8125 6.5ZM6 7.67188C6.58594 7.67188 7.07812 8.16406 7.07812 8.75C7.07812 9.35938 6.58594 9.82812 6 9.82812C5.39062 9.82812 4.92188 9.35938 4.92188 8.75C4.92188 8.16406 5.39062 7.67188 6 7.67188ZM4.96875 3.80469C4.94531 3.64062 5.08594 3.5 5.25 3.5H6.72656C6.89062 3.5 7.03125 3.64062 7.00781 3.80469L6.84375 6.99219C6.82031 7.15625 6.70312 7.25 6.5625 7.25H5.41406C5.27344 7.25 5.15625 7.15625 5.13281 6.99219L4.96875 3.80469Z",
  fill: "#F96274"
});

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-icon.9c7cc756.svg";
export { ForwardRef as ReactComponent };